/*
 * dd-am-video.js: lazy playback, the pause control for dd-am-video-band, and prefers-reduced-motion.
 * Loaded only by that section. Binds to its own button and video, never to document,
 * so it cannot interfere with the theme or with any other section.
 *
 * The <video> ships preload="none" with no autoplay attribute, so it costs 0 bytes until
 * play() runs. play() runs only while the band is within ~200px of the viewport and motion
 * is allowed, and the video pauses again off-screen (no decoding a loop nobody sees).
 */
(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  function wire(band) {
    const video = band.querySelector("video");
    const toggle = band.querySelector("[data-dd-am-video-toggle]");
    if (!video || !toggle || band.dataset.ddAmVideoWired) return;
    band.dataset.ddAmVideoWired = "1";
    video.muted = true; // play() without a gesture is allowed only for a muted video

    const render = () => {
      const paused = video.paused;
      toggle.setAttribute("aria-pressed", String(paused));
      toggle.setAttribute("aria-label", paused ? "Play the background video" : "Pause the background video");
    };
    // The shopper's own choice wins over the motion preference and the viewport once they press the button.
    let chosen = false;
    let near = false;
    const applyPreference = () => {
      if (chosen) return;
      if (near && !reduce.matches) video.play().catch(() => {});
      else if (!video.paused) video.pause();
    };

    toggle.addEventListener("click", () => {
      chosen = true;
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });
    video.addEventListener("play", render);
    video.addEventListener("pause", render);
    reduce.addEventListener("change", applyPreference);

    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        near = entries[entries.length - 1].isIntersecting;
        applyPreference();
      }, { rootMargin: "200px 0px" }).observe(band);
    } else {
      near = true;
      applyPreference();
    }
    render();
  }

  document.querySelectorAll("[data-dd-am-video]").forEach(wire);
})();
